import { globalLoggerToken } from "@/tokens";
import { container, singleton } from "tsyringe";

import { ModuleInterface } from "@interfaces/ModuleInterface";

import CanvasManager from "./CanvasManager/CanvasManager";

type CanvasModuleExports = {
    canvasManager: CanvasManager;
};

@singleton()
export class CanvasModule implements ModuleInterface<CanvasModuleExports> {
    exports: CanvasModuleExports;
    public constructor() {
        const logger = container
            .resolve(globalLoggerToken)
            .newLogger("CanvasModule");

        const canvasManager = new CanvasManager(logger);

        this.exports = {
            canvasManager,
        };
    }
    public registerProviders() {
        return {};
    }
}
